import { render, staticRenderFns } from "./Card1Demo.vue?vue&type=template&id=4158c4d2&scoped=true&"
import script from "./Card1Demo.vue?vue&type=script&lang=js&"
export * from "./Card1Demo.vue?vue&type=script&lang=js&"
import style0 from "./Card1Demo.vue?vue&type=style&index=0&id=4158c4d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158c4d2",
  null
  
)

export default component.exports